// extracted by mini-css-extract-plugin
module.exports = {"Welcome":"Welcome_Welcome__1unZH","bodyText":"Welcome_bodyText__3xF1z"};